<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <div class="row mb-3">
      <label for="zone" class="col-form-label col-xl-2">เขต</label>
      <div class="col-xl-3">
        <app-select-zone id="zone" name="zone" [(ngModel)]="params().zone"></app-select-zone>
      </div>

      <label for="province" class="col-form-label col-xl-2">จังหวัด</label>
      <div class="col-xl-3">
        <app-province-autocomplete id="province" name="province" [restrictZone]="params().zone"
                                   [(ngModel)]="params().province"></app-province-autocomplete>
      </div>
    </div>
    <div class="row mb-3">
      <label class="col-form-label col-xl-2">หน่วยบริการ</label>
      <div class="col-xl-4">
        <app-hospital-autocomplete id="hospital" name="hospital"
                                   [(ngModel)]="params().hospital"></app-hospital-autocomplete>
      </div>
    </div>
    <div class="row">
      <div class="offset-xl-2">
        <button type="button" (click)="search()" class="btn btn-primary me-2"><i class="bi bi-search me-1"></i>ค้นหาข้อมูล
        </button>
        <button type="reset" class="btn btn-default" (click)="reset()">ล้างค่า</button>
      </div>
    </div>
  </div>
</div>
<div class="row mb-3">
  <div class="col-12">
    <button class="btn btn-success float-end" (click)="add()">
      <i class="bi bi-plus-lg me-1"></i>
      เพิ่มข้อมูล
    </button>
  </div>
</div>
<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-striped table-borderless caption-top">
        <caption>
          แสดง {{ (pageData?.content?.length ? (pageData?.number * pageData?.size) + 1 : 0) | number }}
          ถึง {{ ((pageData?.number) * pageData?.size + pageData?.content?.length) | number }}
          จากทั้งหมด {{ pageData?.totalElements | number }} รายการ
        </caption>
        <thead class="color-black font-weight-light">
        <tr class="table-light" style="background-color: #eeeeee;">
          <th nowrap class="text-center" scope="col">ลำดับ</th>
          <th nowrap class="text-center" scope="col">รหัสหน่วยบริการ</th>
          <th nowrap scope="col" class="">ชื่อหน่วยบริการ</th>
          <th nowrap scope="col" class="">จังหวัด</th>
          <th nowrap scope="col" class="">เขต</th>
          <th nowrap class="text-center" scope="col" class="">วันที่ออกจากโครงการ</th>
          <th nowrap class="text-center" scope="col">ดำเนินการ</th>
        </tr>
        </thead>
        <tbody class="table-borderless">
          @for (item of pageData?.content; let idx = $index; track item.id) {
            <tr>
              <td nowrap class="text-center">{{ (pageData.size * pageData.number) + (idx + 1) }}</td>
              <td nowrap class="text-center">{{ item.hospital?.hcode || '-' }}</td>
              <td nowrap class="">{{ item.hospital?.displayName || '-' }}</td>
              <td nowrap class="">{{ item.hospital?.province?.name || '-' }}</td>
              <td nowrap class="">{{ item.hospital?.province?.zone?.name || '-' }}</td>
              <td nowrap class="col-date">{{ (item.id?.dateOut | thaidatetime) || '-' }}</td>
              <td nowrap class="text-center">
                <button type="button" (click)="view(item)" class="btn btn-default btn-sm me-2">
                  <i class="bi bi-eye"></i>
                </button>
<!--                <button type="button" (click)="edit(item)" class="btn btn-default btn-sm">-->
<!--                  <i class="bi bi-pencil"></i>-->
<!--                </button>  -->
                <button type="button" (click)="remove(item)" class="btn btn-danger btn-sm">
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="7">
                <app-not-found></app-not-found>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <ngb-pagination class="d-flex justify-content-center"
                    [maxSize]="5"
                    [rotate]="true"
                    [ellipses]="false"
                    [boundaryLinks]="true"
                    [page]="pageData?.number + 1"
                    (pageChange)="search($event)"
                    [pageSize]="pageData?.size"
                    [collectionSize]="pageData?.totalElements"></ngb-pagination>
  </div>
</div>
